import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AttachmentType } from './model/attachmentType';
import { PreregApplicationService } from './service/prereg.service';
import { environment } from '../../environments/environment';

interface SupportingDocument {
    type: AttachmentType;
    filename: string;
    url?: string;
    downloadUrl?: string;
    fromArchive?: boolean;
    expiryDate?: string | Date;
    certifier?: {
        companyName?: string | null;
        date?: string | Date | null;
        name?: string | null;
        number?: string | null;
    } | null;
}

interface SupportingDocumentsApplication {
    supportingDocuments?: SupportingDocument[];
    form?: {
        attachments?: SupportingDocument[];
    };
}

@Component({
    selector: 'app-application-supporting-docs',
    templateUrl: './applicationSupportingDocs.component.html',
    styleUrls: ['./applicationSupportingDocs.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationSupportingDocsComponent {
    @Input() application?: SupportingDocumentsApplication;
    @Input() isStudent = false;
    attachmentType = AttachmentType;
    downloading = false;
    downloadClickCount = 0;
    attachments: SupportingDocument[] = [];
    @Input() isCountersignerView = false;
    @Input() isAros = false;
    @Input() isPrescriber = false;
    @Input() isRTR = false;
    @Input() isCCPS = false;
    supportingDocs: SupportingDocument[] = [];

    constructor(
        private service: PreregApplicationService
    ) { }
    ngOnInit() {
        if(this.isRTR || this.isCCPS) {
            this.supportingDocs = this.application?.form?.attachments ?? [];
        } else {
            this.supportingDocs = this.application?.supportingDocuments ?? [];
        }

        if (this.isCountersignerView) {
            this.supportingDocs = this.supportingDocs.filter(this.removePhotoDocsFromSupportingDocs);
        }
    }

    removePhotoDocsFromSupportingDocs(document: SupportingDocument): boolean {
        return document.type !== AttachmentType.Photo;
    }

    getIcon(file: SupportingDocument): string {
        const bits = file.filename.split('.');
        const extension = bits[bits.length - 1];
        switch (extension) {
            case 'pdf':
                return 'fa fa-file-pdf-o';
            case 'png':
            case 'jpg':
            case 'bmp':
            case 'gif':
                return 'fa fa-file-image-o';
            case 'doc':
            case 'docx':
                return 'fa fa-file-word-o';
            case 'zip':
            case 'rar':
                return 'fa fa-file-archive-o';
            default:
                return 'fa fa-file-o';
        }
    }

    download(file: SupportingDocument): void {
        const downloadUrl = file.downloadUrl ?? file.url;
        if (!downloadUrl) {
            throw new Error(`No download URL is available for ${file.filename}`);
        }
        this.downloading = true;
        this.downloadClickCount += 1;
        const param = file.fromArchive
                    ? downloadUrl
                    : environment.api.root + '/' + downloadUrl;
        this.service.download(param).subscribe(blob => {
            this.downloading = false;
            setTimeout(() => {
                this.downloadClickCount -= 1;
            }, 2000);
                const url = URL.createObjectURL(blob);
                const element = document.createElement('a');
                element.href = url;
                element.setAttribute('download', file.filename);
                document.body.appendChild(element); // Append the element to work in firefox
                element.click();
        });
    }
}
